export const FETCH_GALLERIES_INIT = 'FETCH_GALLERIES_INIT'
export const FETCH_GALLERIES_SUCCESS = 'FETCH_GALLERIES_SUCCESS'
export const SET_GALLERIES_LOADER = 'galleries/SET_GALLERIES_LOADER'
export const UPDATE_SORT_BY = 'galleries/UPDATE_SORT_BY'
export const RESET_GALLERIES = 'galleries/RESET_GALLERIES'
